/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  import ApplicationState from "store/application";

  const __vue_script__ = {
    name: "SidebarItem",
    data() {
      const { component } = this.$options;
      return {
        info:        component.info || { state: null, style: null, class: null },
        main:        true,
        component,
        active:      false,
        title:       component.title || '',
        open:        !!component.state.open,
        icon:        component.icon,
        iconColor:   component.iconColor,
        collapsible: false !== component.collapsible,
        actions:     component.actions,
        sidebar :    ApplicationState.gui.sidebar
      };
    },
    methods: {
      triggerAction(action, component) {
        action.fnc(component);
      },
    },

    mounted() {
      const opts    = this.$options.opts || {};
      const sidebar = document.getElementById('g3w-sidebarcomponents');

      // append to `g3w-sidebarcomponents`
      if ([null, undefined].includes(opts.position) || opts.position < 0 || opts.position >= sidebar.children.length) {
        $(sidebar).append(this.$el);
      }
  
      // append to `g3w-sidebarcomponents` (by position)
      else {
        Array.from(sidebar.children).forEach((child, i) => {
          if (i === opts.position || child.id === opts.position) {
            child.insertAdjacentElement((!!opts.before || undefined === opts.before) ? 'beforebegin' : 'afterend', this.$el);
          }
        });
      }

      this.component.mount(this.$refs['component-placeholder']);

      // set component click handler
      this.component.click = ({ open = false } = {}) => {
        if (open) {
          ApplicationState.sidebar.components.forEach(comp => {
            if (comp !== this.component && comp.getOpen()) {
              comp.click({ open: false });
            }
          });
        }
        const node = this.component.getInternalComponent().$el;
        //@since 3.11.0 Need to add check of sidebar components, in case, for example, close
        // contents element and some sidebar component is related to it's close, for example, qplotly
        //a toggle menu open of <ul>
        if (node.classList) {
          node.classList.toggle('menu-open', open);
        }
        // toggle active of <li> element
        node.parentNode.classList.toggle('active', open);

        this.component.setOpen(open);

      };
    },

  }

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.component.state.visible),expression:"component.state.visible"},{name:"disabled",rawName:"v-disabled",value:(_vm.component.state.disabled),expression:"component.state.disabled"}],staticClass:"treeview sidebaritem",class:{'active': _vm.open },attrs:{"id":_vm.component.id}},[_c('bar-loader',{attrs:{"loading":_vm.component.state.loading}}),_vm._v(" "),_c('a',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:(_vm.sidebar.open ? '' : _vm.title),expression:"sidebar.open ? '' : title",arg:"right",modifiers:{"create":true}}],staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"},attrs:{"href":"#","current-tooltip":_vm.sidebar.open ? '' : _vm.title}},[_c('div',[(!_vm.sidebar.open)?_c('span',[_c('i',{class:_vm.icon,style:({ color: _vm.iconColor })})]):_c('i',{class:_vm.icon,style:({ color: _vm.iconColor })}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.title),expression:"title"}],staticClass:"treeview-label"})]),_vm._v(" "),_c('div',[(_vm.info.state)?_c('span',{class:_vm.info.class,staticStyle:{"position":"absolute","right":"5px","font-weight":"bold"},style:(_vm.info.style),attrs:{"title":_vm.info.tooltip}},[_vm._v(_vm._s(_vm.info.state))]):_vm._e(),_vm._v(" "),_vm._l((_vm.actions),function(action){return _c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:(action.tooltip),expression:"action.tooltip",arg:"left",modifiers:{"create":true}}],key:action.id,staticClass:"action skin-tooltip-left",class:action.class,staticStyle:{"font-weight":"bold","padding":"3px"},style:(action.style),on:{"click":function($event){$event.stopPropagation();return _vm.triggerAction(action, _vm.component.internalComponent)}}})})],2),_vm._v(" "),(_vm.collapsible)?_c('i',{staticClass:"pull-right",class:_vm.$fa('angle-left')}):_vm._e()]),_vm._v(" "),_c('div',{ref:"component-placeholder"})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SidebarItem.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__